$(document).ready(function () {
  const sliders = $('.team-slider');

  sliders.each(function (index) {
    const $slider = $(this);
    const totalSlides = $slider.find('.team-member').length;
    const slidesToShow = 4;

    const baseInitial = Math.floor((totalSlides - slidesToShow) / 2);
    const initialSlide = baseInitial - index;

    $slider.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      centerMode: false,
      initialSlide: initialSlide,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            initialSlide: Math.floor((totalSlides - 2) / 2) + index,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            initialSlide: Math.floor((totalSlides - 1) / 2) + index,
          },
        },
      ],
    });
  });
  $('.team-arrow-next').on('click', function () {
    sliders.each(function () {
      $(this).slick('slickNext');
    });
  });

  $('.team-arrow-prev').on('click', function () {
    sliders.each(function () {
      $(this).slick('slickPrev');
    });
  });
});
